import { useNavigate } from 'react-router-dom'

const Unauthorized = () => {
  const navigate = useNavigate()

  return (
    <main style={{ height: '75vh' }}>
      <div className='d-flex h-100 justify-content-center align-items-center'>
        <div className='mx-auto text-center'>
          <h1
            style={{
              fontSize: '256px',
              fontWeight: 'bolder',
              letterSpacing: '15px',
              background: 'var(--primary-gradient)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            403
          </h1>
          <h4 className='text-capitalize text-bold mt-4'>unauthorized access</h4>
          <p className='text-capitalize text-secondary'>sorry, you don't have permission to access this page</p>
          <button onClick={() => navigate(-1)} className='common-btn px-4 py-3' style={{ fontSize: '22px' }}>
            Go Back
          </button>
        </div>
      </div>
    </main>
  )
}

export default Unauthorized
